import { memo } from "react";

import { ResponsivePie } from "@nivo/pie";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import { GenericObject } from "utility/misc";

// -----------------------------------------------------------------------------

const PieDisplay = memo(function PieDisplay({
  title,
  data = [],
  loading = false,
}: PieDisplayProps) {
  const hasAtLeastOneDatapoint = data.some(
    (entry: GenericObject) => entry.value > 0
  );

  const CenteredMetric = ({ dataWithArc, centerX, centerY }: any) => {
    let total = 0;
    dataWithArc.forEach((datum: { value: number }) => {
      total += datum.value;
    });

    return (
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontSize: "18px",
          fontWeight: 600,
        }}
      >
        {total}
      </text>
    );
  };

  //
  return (
    <Card sx={{ overflow: "visible" }}>
      <CardContent>
        <Typography variant="overline">{title}</Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" fontWeight="bold">
            {loading ? (
              <>
                &nbsp;
                <CircularProgress size={20} />
              </>
            ) : !hasAtLeastOneDatapoint ? (
              "None"
            ) : null}
          </Typography>
        </Box>
      </CardContent>
      {hasAtLeastOneDatapoint ? (
        <Box sx={{ height: 256 }}>
          <ResponsivePie
            margin={{ top: 10, right: 10, bottom: 10, left: -200 }}
            colors={{ datum: "data.color" }}
            borderWidth={1}
            borderColor={{
              from: "color",
              modifiers: [["darker", 0.5]],
            }}
            activeOuterRadiusOffset={4}
            innerRadius={0.75}
            padAngle={1}
            cornerRadius={1}
            enableArcLabels={false}
            enableArcLinkLabels={false}
            data={data as any}
            layers={[
              "arcs",
              "arcLabels",
              "arcLinkLabels",
              "legends",
              CenteredMetric,
            ]}
            legends={[
              {
                anchor: "right",
                direction: "column",
                justify: false,
                translateX: -150,
                translateY: 0,
                itemsSpacing: 12,
                itemWidth: 50,
                itemHeight: 18,
                itemTextColor: "#999",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: "square",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#000",
                    },
                  },
                ],
              },
            ]}
          />
        </Box>
      ) : null}
    </Card>
  );
});

export default PieDisplay;

// -----------------------------------------------------------------------------

interface PieDisplayProps {
  title: JSX.Element;
  data: GenericObject;
  loading?: boolean;
}
